import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { ValueLength } from "./ValueLength";

export interface ValueLengthContainerProps {
    bindingPath: AbsoluteModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: ValueLengthContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;

    return {
        value: viewModelSelect.controlModel(state, bindingPath).value,
    };
};

export const ValueLengthContainer = withResolvePaths(
    withViewModelSelect(connect(mapStateToProps)(withControlDebugInfo(ValueLength)))
);
